import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/settings/"
)({
  beforeLoad({ params }) {
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/settings/user-verification",
      params,
    });
  },
  loader: () => ({
    crumb: "Settings",
  }),
});
